import { render, staticRenderFns } from "./TargetSearch.vue?vue&type=template&id=52479623&"
import script from "./TargetSearch.vue?vue&type=script&lang=js&"
export * from "./TargetSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports